import styled from 'styled-components'

export const GroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const RadioOption = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid ${({ $selected }) => ($selected ? 'var(--color-brand-live)' : 'var(--vo-cloud)')};
  border-radius: var(--radius-md);
  background: ${({ $selected }) => ($selected ? 'var(--color-brand-live-8)' : 'white')};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  transition: border-color 0.2s, background 0.2s;

  &:hover {
    border-color: ${({ $disabled }) => ($disabled ? 'var(--vo-cloud)' : 'var(--color-brand-live)')};
  }
`

export const RadioContent = styled.div`
  display: flex;
  flex-direction: column;
`

export const RadioLabel = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: var(--vo-ink);
`

export const RadioDescription = styled.span`
  font-size: 12px;
  color: var(--vo-slate);
  margin-top: 2px;
`
